
import { useTheme, useMediaQuery } from '@mui/material';

const useResponsive = () => {

  const theme = useTheme();

  const isExtraSmall = useMediaQuery(theme.breakpoints.down('xs'));

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));

  return { isExtraSmall, isSmallScreen, isMediumScreen };

};

export default useResponsive; 